<template>
        <div class="background-grey"></div>
        <div class="toolbar">
            <ViewMode></ViewMode>
        </div>
        <MapCt                                                                               v-if="(viewTypeName == 'map')"/>
        <BarChartCt                                                                          v-if="(viewTypeName == 'bar-chart')"/>
        <TableCt                  v-if=" assessment.isGeographic()          && (stepIndex == 1) && (viewTypeName == 'table')"/>
        <ProductionAccountTableCt v-if="(assessmentTypeName == 'commodity') && (stepIndex == 1) && (viewTypeName == 'table')"/>
        <GeographicSustainTableCt v-if=" assessment.isGeographic()          && (stepIndex == 2) && (viewTypeName == 'table')"/>
        <GeographicSustainTableCt v-if="(assessmentTypeName == 'commodity') && (stepIndex == 2) && (viewTypeName == 'table')"/>
        <ProcessSustainTableCt    v-if="(assessmentTypeName == 'business')  && (stepIndex == 2) && (viewTypeName == 'table')"/>
<!--        <div class="wt-container" v-if="(assessmentTypeName == 'hbasins')   && (stepIndex == 2) && (viewTypeName == 'table')"><p class="introduction-text text-center">Sustainability is not yet available for Hydrosheds-based assessment.</p></div> -->
        <GeographicRespondTableCt v-if=" assessment.isGeographic()          && (stepIndex == 3) && (viewTypeName == 'table')"/>
        <GeographicRespondTableCt v-if="(assessmentTypeName == 'commodity') && (stepIndex == 3) && (viewTypeName == 'table')"/>
        <div class="wt-container" v-if="(assessmentTypeName == 'business')  && (stepIndex == 3) && (viewTypeName == 'table')"><p class="introduction-text text-center">Response options are not yet available for business assessment.</p></div>
        <div class="wt-container" v-if="(assessmentTypeName == 'hbasins')   && (stepIndex == 3) && (viewTypeName == 'table')"><p class="introduction-text text-center">Response options are not yet available for Hydrosheds-based assessment.</p></div>
        <PieChartCt                                                                          v-if="(viewTypeName == 'pie-chart')"/>
        <HydroCt                                                                             v-if="(viewTypeName == 'hydrograph')"/>
        

        <div class="left-toolbar">
            <div v-if="view.viewColors && (view.viewColors.length > 1) && (assessment.branding != 'sbtn')" class="buttonbar">
                <div class="color-item"
                    v-for="viewColor in view.viewColors"
                    :key="viewColor"
                    @click="assessment.setViewColor(viewColor, true)"
                    :title="'Show the ' + viewColor + ' water footprint'"
                    :class="{
                        green: viewColor === 'green',
                        blue: viewColor === 'blue',
                        grey: viewColor === 'grey',
                        total: viewColor === 'total',
                        active: assessment.viewColor == viewColor
                    }"
                >{{viewColor}}</div>
            </div>
            <div class="buttonbar">
                <div v-if="view.hasCrops" @click="showCropDialog()" title="Select a crop or sector" class="manage-item">
                    <img src="../assets/img/crop.svg" height="35" alt/>
                </div>
                <template v-if="assessment.scenario && (assessment.branding != 'sbtn')">
                    <div v-if="assessment.scenario.type == 10" @click="showUpgradeScenarioDialog()" title="Manage your supply chain" class="manage-item">
                        <img src="../assets/img/crop.svg" height="35" alt/>
                        <div class="position-absolute badge rounded-pill text-bg-secondary">0</div>
                    </div>
                    <div v-if="assessment.scenario.type % 10 == 1" @click="showScenarioCountryCropDialog()" :title="'Manage your ' + rawMaterialsText" class="manage-item">
                        <img src="../assets/img/crop.svg" height="35" alt/>
                        <div class="position-absolute badge rounded-pill text-bg-secondary">{{ scenarioCountryCrops.length }}</div>
                    </div>
                    <div v-if="assessment.scenario.type % 100 >= 10" @click="showScenarioProcessSubstanceDialog()" title="Manage your locations" class="manage-item">
                        <img src="../assets/img/icons/industry.svg" height="35" alt/>
                        <div class="position-absolute badge rounded-pill text-bg-primary">{{ scenarioProcesses.length }}</div>
                    </div>
                </template>
            </div>
        </div>
</template>

<script>
import { assessment } from "@/services/assessment-model.js";
import { modalTypes, openModal } from "@/services/modal-model";
import ViewMode from "@/components/shared/ViewMode.vue";
import TableCt from "@/views/TableCt.vue";
import GeographicSustainTableCt from "@/views/GeographicSustainTableCt.vue";
import GeographicRespondTableCt from "@/views/GeographicRespondTableCt.vue";
import BarChartCt from "@/views/BarChartCt.vue";
import PieChartCt from "@/views/PieChartCt.vue";
import HydroCt from "@/views/HydroCt.vue";
import MapCt from "@/views/MapCt.vue";
import ProcessSustainTableCt from "@/views/ProcessSustainTableCt.vue";
import ProductionAccountTableCt from "@/views/ProductionAccountTableCt.vue";
import { getCrop, scenarioCountryCrops, scenarioProcesses } from "@/services/entity-model.js";

export default {
    name: 'Main',
    data() {
        return {
            assessment,
            scenarioCountryCrops,
            scenarioProcesses
        }
    },
    components: {
        ViewMode,
        MapCt,
        BarChartCt,
        PieChartCt,
        TableCt,
        GeographicSustainTableCt,
        GeographicRespondTableCt,
        HydroCt,
        ProductionAccountTableCt,
        ProcessSustainTableCt
    },
    computed: {
        assessmentTypeName() {
            return this.assessment.assessmentType.name;
        },
        stepIndex() {
            return this.assessment.step.index;
        },
        viewTypeName() {
            return this.assessment.viewType.name;
        },
        view() {
            return this.assessment.assessmentType.steps[this.assessment.step.index].views.find(view => view.viewType == this.assessment.viewType);
        },
        rawMaterialsText() {
            if (this.assessment.assessmentType.name == "commodity") {
                return "raw materials";
            }
            return "supply chain";
        }
    },
    methods: {
        showCropDialog: function() {
            openModal(modalTypes.crop, {
                tempCrop: this.assessment.crop || getCrop(100001),
                setCrop: crop => this.assessment.setCrop(crop, true),
            /*}, { 
                draggable: true,*/ 
                width: 650/*, 
                height: "auto" 
            */});
        },
        showUpgradeScenarioDialog: function() {
            openModal(modalTypes.scenario, { width: 700/*, height: "auto", draggable: false, scrollable: true*/ });
        },
        showScenarioCountryCropDialog: function() {
            openModal(modalTypes.scenarioCountryCrop, {/*
                draggable: true,*/
                width: 700/*,
                height: "auto"
            */});
        },
        showScenarioProcessSubstanceDialog: function() {
            openModal(modalTypes.scenarioProcess, {/*
                draggable: true, */
                width: 900/*,
                height: "auto"
            */});
        }
    }
}
</script>

<style lang="scss" scoped>
.toolbar {
    z-index: 5;
    position: absolute;
    right: 0;
    top: 100px;
}

.left-toolbar {
    z-index: 5;
    position: absolute;
    left: 0;
    top: 100px;
    pointer-events: none;
}
.buttonbar {
    overflow: hidden;
    background-color: grey;
    border: 1px sold #707070;
    border-bottom-right-radius: 10px;
    border-top-right-radius: 10px;
    background-color: #edebe5;
    margin-bottom: 20px;
    text-transform: capitalize; 
    pointer-events: all;
    .color-item {
        cursor: pointer;
        padding: 16px 12px;
        &.green {
            &.active, &:hover {
                background-color: #6eb3a2;
                color: white;
            }
        }
        &.blue {
            &.active, &:hover {
                background-color: #349bd1;
                color: white;
            }
        }
        &.grey {
            &.active, &:hover {
                background-color: #626262;
                color: white;
            }
        }
        &.total {
            &.active, &:hover {
                background-color: #e45a00;
                color: white;
            }
        }
    }
    .manage-item {
        cursor: pointer;
        padding: 10px 15px;
        &.open, &:hover {
            background-color: white;
        }
    }
}

.background-grey {
    position: fixed;
    top: 0;
    width: 100%;
    height: 100vh;
    z-index: -1;
    background: #cccccc; /* Old browsers */
    background: -moz-linear-gradient(top,  #cccccc 0%, #ececec 100%); /* FF3.6-15 */
    background: -webkit-linear-gradient(top,  #cccccc 0%,#ececec 100%); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(to bottom,  #cccccc 0%,#ececec 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#cccccc', endColorstr='#ececec',GradientType=0 ); /* IE6-9 */
}
</style>


